export const MAPPED_RAILWAYS_COUNTRIES = {
  KZ: 'KAZ',
  CN: 'CHN',
  RU: 'RUS',
  UZ: 'UZB',
  BY: 'BLR',
  AU: 'AUS',
  AT: 'AUT',
  AZ: 'AZE',
  AL: 'ALB',
  DZ: 'DZA',
  AS: 'ASM',
  AI: 'AIA',
  AO: 'AGO',
  AD: 'AND',
  AG: 'ATG',
  AN: 'ANT',
  AR: 'ARG',
  AM: 'ARM',
  AW: 'ABW',
  AF: 'AFG',
  BS: 'BHS',
  BD: 'BGD',
  BB: 'BRB',
  BH: 'BHR',
  BZ: 'BLZ',
  BE: 'BEL',
  BJ: 'BEN',
  BM: 'BMU',
  BG: 'BGR',
  BO: 'BOL',
  BA: 'BIH',
  BW: 'BWA',
  BR: 'BRA',
  IO: 'IOT',
  BN: 'BRN',
  BF: 'BFA',
  BI: 'BDI',
  BT: 'BTN',
  VU: 'VUT',
  VA: 'VAT',
  GB: 'GBR',
  HU: 'HUN',
  VE: 'VEN',
  VG: 'VGB',
  TL: 'TLS',
  VN: 'VNM',
  GA: 'GAB',
  HT: 'HTI',
  GY: 'GUY',
  GM: 'GMB',
  GH: 'GHA',
  GT: 'GTM',
  GN: 'GIN',
  GW: 'GNB',
  DE: 'DEU',
  GG: 'GGY',
  GI: 'GIB',
  HN: 'HND',
  HK: 'HKG',
  GD: 'GRD',
  GL: 'GRL',
  GR: 'GRC',
  GE: 'GEO',
  GU: 'GUM',
  DK: 'DNK',
  DJ: 'DJI',
  DM: 'DMA',
  DO: 'DOM',
  EG: 'EGY',
  ZM: 'ZMB',
  EH: 'ESH',
  ZW: 'ZWE',
  IL: 'ISR',
  IN: 'IND',
  ID: 'IDN',
  JO: 'JOR',
  IQ: 'IRQ',
  IR: 'IRN',
  IE: 'IRL',
  IS: 'ISL',
  ES: 'ESP',
  IT: 'ITA',
  YE: 'YEM',
  CV: 'CPV',
  KY: 'CYM',
  KH: 'KHM',
  CM: 'CMR',
  CA: 'CAN',
  QA: 'QAT',
  KE: 'KEN',
  CY: 'CYP',
  KG: 'KGZ',
  KI: 'KIR',
  CC: 'CCK',
  CO: 'COL',
  KM: 'COM',
  CG: 'COG',
  CD: 'COD',
  KP: 'PRK',
  KR: 'KOR',
  CR: 'CRI',
  CU: 'CUB',
  CI: 'CIV',
  KW: 'KWT',
  LA: 'LAO',
  LV: 'LVA',
  LS: 'LSO',
  LR: 'LBR',
  LB: 'LBN',
  LY: 'LBY',
  LT: 'LTU',
  LI: 'LIE',
  LU: 'LUX',
  MU: 'MUS',
  MR: 'MRT',
  MG: 'MDG',
  YT: 'MYT',
  MO: 'MAC',
  MK: 'MKD',
  MW: 'MWI',
  MY: 'MYS',
  ML: 'MLI',
  MV: 'MDV',
  MT: 'MLT',
  MP: 'MNP',
  MA: 'MAR',
  MH: 'MHL',
  MX: 'MEX',
  FM: 'FSM',
  MZ: 'MOZ',
  MD: 'MDA',
  MC: 'MCO',
  MN: 'MNG',
  MS: 'MSR',
  MM: 'MMR',
  NA: 'NAM',
  NR: 'NRU',
  NP: 'NPL',
  NE: 'NER',
  NG: 'NGA',
  NL: 'NLD',
  NI: 'NIC',
  NU: 'NIU',
  NZ: 'NZL',
  NC: 'NCL',
  NO: 'NOR',
  AE: 'ARE',
  OM: 'OMN',
  IM: 'IMN',
  CX: 'CXR',
  SH: 'SHN',
  JE: 'JEY',
  CK: 'COK',
  TC: 'TCA',
  WF: 'WLF',
  SJ: 'SJM',
  PK: 'PAK',
  PW: 'PLW',
  PS: 'PSE',
  PA: 'PAN',
  PG: 'PNG',
  PY: 'PRY',
  PE: 'PER',
  PN: 'PCN',
  PF: 'PYF',
  PL: 'POL',
  PT: 'PRT',
  RE: 'REU',
  RW: 'RWA',
  RO: 'ROU',
  WS: 'WSM',
  SM: 'SMR',
  ST: 'STP',
  SA: 'SAU',
  SZ: 'SWZ',
  SC: 'SYC',
  SN: 'SEN',
  VC: 'VCT',
  KN: 'KNA',
  LC: 'LCA',
  PM: 'SPM',
  RS: 'SRB',
  SG: 'SGP',
  SY: 'SYR',
  SK: 'SVK',
  SI: 'SVN',
  SB: 'SLB',
  SO: 'SOM',
  SD: 'SDN',
  SR: 'SUR',
  US: 'USA',
  SL: 'SLE',
  TJ: 'TJK',
  TH: 'THA',
  TW: 'TWN',
  TZ: 'TZA',
  TG: 'TGO',
  TK: 'TKL',
  TO: 'TON',
  TT: 'TTO',
  TV: 'TUV',
  TN: 'TUN',
  TM: 'TKM',
  TR: 'TUR',
  UG: 'UGA',
  UA: 'UKR',
  UY: 'URY',
  FO: 'FRO',
  FJ: 'FJI',
  PH: 'PHL',
  FI: 'FIN',
  FK: 'FLK',
  FR: 'FRA',
  HR: 'HRV',
  CF: 'CAF',
  TD: 'TCD',
  ME: 'MNE',
  CZ: 'CZE',
  CL: 'CHL',
  CH: 'CHE',
  SE: 'SWE',
  LK: 'LKA',
  EC: 'ECU',
  GQ: 'GNQ',
  SV: 'SLV',
  ER: 'ERI',
  EE: 'EST',
  ET: 'ETH',
  ZA: 'ZAF',
  JM: 'JAM',
  JP: 'JPN',
} as Record<string, string>; // TODO: Workaround until we add types of platform countries code
